import {Directive,  Input} from '@angular/core';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';
import { _countGroupLabelsBeforeLegacyOption as _countGroupLabelsBeforeOption, _getLegacyOptionScrollPosition as _getOptionScrollPosition } from '@angular/material/legacy-core';


/**
 * This directive is an override of matAucomplete
 * The goal is to neutralize the default operation which automatically closes the panel
 * to manage multiple selection
 * LMA : neutralisation de la fermeture du panel sur open, click puis space...
 */
@Directive({
  selector: `input[wizAutocomplete]`,
  host: {
    class: 'mat-autocomplete-trigger',
    // Note: we use `focusin`, as opposed to `focus`, in order to open the panel
    // a little earlier. This avoids issues where IE delays the focusing of the input.
    '(focusin)': '_handleFocus()',
    // '(blur)': '_onTouched()',
    // '(input)': '_handleInput($event)',
    '(keydown)': '_handleKeydown($event)'
  },
  exportAs: 'wizAutocompleteTrigger',
})
export class WizAutocompleteTrigger extends MatAutocompleteTrigger {

  @Input('wizAutocomplete') declare autocomplete: MatAutocomplete;
  @Input('component') component:any;
  /** interception du keydown dans l'input comme dans la popUp */
  public _handleKeydown(event: KeyboardEvent): void {
    // neutralisation pour gestion dans dropdown.ts
  }

  /** interception du focusIn pour ne pas systématiquement ouvrir la popUp */
  public _handleFocus(): void {
    // neutralisation pour gestion dans dropdown.ts
    // console.log(' dir _handleFocus');
  }

  /** interception de la demande de fermeture pour neutralisation */
  public closePanel(): void {
    // console.log(' dir closePanel',this.component);
    if(this.component.preventClosure){
      // rien, annulation du close
      // console.log(' dir closePanel','prevent');
    } else {
      super.closePanel();
      // console.log(' dir closePanel','do');
    }
    this.component.preventClosure = false;
  }
}
